import ToolTip from '../../../Shared/ToolTip'
import Button from '../../../Shared/Form/Button'
import React, { memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import './style.scss'
import activityTrackingService from '../../../../services/activityTrackingService'
import { trackingEvent } from '../../../../constants'
import { propertyActions } from '../../../../redux/actions/property'

const PublishAllButton = memo(({ giataId, publishAllowed = true }) => {
  const dispatch = useDispatch()
  const hasUnpublishedChanges = useSelector(state => state.property.hasUnpublishedChanges)
  const publishInProgress = useSelector(state => state.property.publishInProgress)
  // this is used to show the lighter button with the unconfirmed images tooltip
  const isPublishBlockedUnconfirmedImages = useSelector(state => state.property.isPublishBlockedDueToUnconfirmedImages)
  const { t } = useTranslation()
  const commonClasses = 'Button-PublishAll Button-Min-Width ToolTip-Handle'
  const enabledClasses = 'Button-Icon-File-Upload'
  const disabledClasses = 'Button-Icon-File-Upload-Grey'
  const publishPossible = publishAllowed && !isPublishBlockedUnconfirmedImages
  const colorClass = publishPossible ? 'Button-Teal' : 'Button-Teal-Light'
  const buttonDisabled = !hasUnpublishedChanges
    // button is not disabled if we have an unconfirmed image state in redux even if publish is not allowed by the prop
    || (!publishAllowed && !isPublishBlockedUnconfirmedImages)
    || publishInProgress
  const onClick = () => {
    if (isPublishBlockedUnconfirmedImages) {
      activityTrackingService.trackEvent(trackingEvent.clickBlockedPublishedButton)
      return
    }
    if (!publishAllowed) {
      return
    }
    activityTrackingService.trackEvent(trackingEvent.publishProperty)
    dispatch(propertyActions.publish(giataId))
  }
  return (
    <Button
      disabled={buttonDisabled}
      onClick={onClick}
      classNames={`${commonClasses} ${colorClass} ${buttonDisabled ? disabledClasses : enabledClasses}`}
    >
      {t('PUBLISH_ALL')}
      {
        !buttonDisabled && publishPossible && <ToolTip className="ToolTip-Bottom">{t('PUBLISH_ALL_TOOLTIP')}</ToolTip>
      }
      {
        !publishPossible
        && isPublishBlockedUnconfirmedImages
        && <ToolTip className="ToolTip-Bottom">{t('CONFIRM_IMAGES_BEFORE_PUBLISH')}</ToolTip>
      }
    </Button>
  )
})

export default PublishAllButton
